import type { SVGProps } from 'react'
const SvgSyNesting = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path fillOpacity={0.24} d="M18 17c0 1.108-.892 2-2 2s-2-.892-2-2 .892-2 2-2 2 .892 2 2" />
		<path d="M18.6 17c0-1.43-1.17-2.6-2.6-2.6s-2.6 1.17-2.6 2.6 1.17 2.6 2.6 2.6 2.6-1.17 2.6-2.6m-1.2 0c0 .786-.614 1.4-1.4 1.4s-1.4-.614-1.4-1.4.614-1.4 1.4-1.4 1.4.614 1.4 1.4" />
		<path fillOpacity={0.24} d="M6 6c0-1.108.892-2 2-2s2 .892 2 2-.892 2-2 2-2-.892-2-2" />
		<path d="M5.4 6c0 1.43 1.17 2.6 2.6 2.6s2.6-1.17 2.6-2.6S9.43 3.4 8 3.4 5.4 4.57 5.4 6m1.2 0c0-.786.614-1.4 1.4-1.4s1.4.614 1.4 1.4S8.786 7.4 8 7.4 6.6 6.786 6.6 6" />
		<path d="M7.4 8v5c0 .943-.004 1.663.079 2.275.082.613.276 1.156.683 1.563s.95.601 1.563.683c.612.083 1.332.079 2.275.079h2v-1.2h-2c-.943 0-1.639-.004-2.115-.068s-.696-.163-.875-.342-.278-.398-.342-.875C8.604 14.64 8.6 13.943 8.6 13V8z" />
	</svg>
)
export default SvgSyNesting
